module.exports = __webpack_public_path__ + "img/banner-shamrock-2023.e5718782.jpg";